const INTRO_KEY = 'realitycheck_has_seen_intro';
const VIEW_KEY = 'realitycheck_view';
const HOME_FILTERS_KEY = 'realitycheck_home_filters';

const VALID_VIEWS = ['home', 'saved', 'recommendations', 'create', 'my-uploads', 'review', 'about'];
const DEVICE_FILTERS = ['all', 'mobile', 'headset', 'desktop'];

export function hasSeenIntro() {
  try {
    return localStorage.getItem(INTRO_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markIntroSeen() {
  try {
    localStorage.setItem(INTRO_KEY, 'true');
  } catch (_) {}
}

export function loadView() {
  try {
    const view = sessionStorage.getItem(VIEW_KEY);
    return VALID_VIEWS.includes(view) ? view : 'home';
  } catch {
    return 'home';
  }
}

export function saveView(view) {
  try {
    if (VALID_VIEWS.includes(view)) {
      sessionStorage.setItem(VIEW_KEY, view);
    }
  } catch (_) {}
}

export function loadHomeFilters() {
  try {
    const raw = sessionStorage.getItem(HOME_FILTERS_KEY);
    if (!raw) {
      return {
        selectedCategory: 'all',
        contentType: 'all',
        searchQuery: '',
        locationQuery: '',
        device: 'all'
      };
    }
    const parsed = JSON.parse(raw);
    return {
      selectedCategory: typeof parsed.selectedCategory === 'string' ? parsed.selectedCategory : 'all',
      contentType: typeof parsed.contentType === 'string' ? parsed.contentType : 'all',
      searchQuery: typeof parsed.searchQuery === 'string' ? parsed.searchQuery : '',
      locationQuery: typeof parsed.locationQuery === 'string' ? parsed.locationQuery : '',
      device: DEVICE_FILTERS.includes(parsed.device) ? parsed.device : 'all'
    };
  } catch {
    return {
      selectedCategory: 'all',
      contentType: 'all',
      searchQuery: '',
      locationQuery: '',
      device: 'all'
    };
  }
}

export function saveHomeFilters(filters) {
  try {
    sessionStorage.setItem(
      HOME_FILTERS_KEY,
      JSON.stringify({
        selectedCategory: filters.selectedCategory,
        contentType: filters.contentType,
        searchQuery: filters.searchQuery,
        locationQuery: filters.locationQuery || '',
        device: DEVICE_FILTERS.includes(filters.device) ? filters.device : 'all'
      })
    );
  } catch (_) {}
}

export const DEFAULT_HOME_FILTERS = {
  selectedCategory: 'all',
  contentType: 'all',
  searchQuery: '',
  locationQuery: '',
  device: 'all'
};

export function resetHomeFilters() {
  saveHomeFilters(DEFAULT_HOME_FILTERS);
  saveView('home');
}
